import { Button } from 'antd';
import styled from 'styled-components';

export const ChangeActivityWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  display: flex;
  min-height: 32px;
  padding: 5px 8px 5px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.black8};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const PlanificationFlowIndicator = styled.div`
  display: flex;
  max-width: 32px;
  min-height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.green3};
  background: ${({ theme }) => theme.colors.green1};
`;
